import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type SnackbarInitialState } from './types';

const initialState: SnackbarInitialState = {
  isSnackbarOpen: false,
  snackbarType: 'warning',
  snackbarMessage: '',
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    openSnackbar: (
      state,
      {
        payload: { snackbarType, snackbarMessage },
      }: PayloadAction<Omit<SnackbarInitialState, 'isSnackbarOpen'>>,
    ) => {
      state.isSnackbarOpen = true;
      state.snackbarType = snackbarType;
      state.snackbarMessage = snackbarMessage;
    },
    closeSnackbar: (state) => {
      state.isSnackbarOpen = false;
    },
  },
});

export const { reducer: snackbarReducer } = snackbarSlice;
